import {
  LayoutDashboard,
  MonitorPlay,
  MessageSquare,
  Gauge,
  Wallet,
  Globe,
  CalendarDays,
  type LucideIcon,
} from 'lucide-react'

export type AthleteNavigationItem = {
  label: string
  path: string
  icon: LucideIcon
  color: string
  end?: boolean
  section?: 'main' | 'secondary'
  showUnreadBadge?: boolean
}

export const athleteNavigationItems: AthleteNavigationItem[] = [
  { label: 'Dashboard', path: '/', icon: LayoutDashboard, color: '#C0FD72', end: true },
  { label: 'Collaborations', path: '/collaborations', icon: MonitorPlay, color: '#FFA07A' },
  {
    label: 'Messages',
    path: '/messages',
    icon: MessageSquare,
    color: '#C0FD72',
    showUnreadBadge: true,
  },
  { label: 'Performance', path: '/performance', icon: Gauge, color: '#9CF0FB' },
  { label: 'Earnings', path: '/earnings', icon: Wallet, color: '#F9DA4C' },
  { label: 'Calendar', path: '/calendar', icon: CalendarDays, color: '#06b6d4' },
  {
    label: 'Public Profile',
    path: '/public-profile',
    icon: Globe,
    color: '#C084FC',
    section: 'secondary',
  },
]
